// Linear gradient used to fill the roll paths inside StandBlock.
// Subtle two-stop metallic gray — top→bottom darkens just enough to suggest
// a polished cylinder lit from above, without the dramatic contrast that a
// 3-stop gradient produces.

export const ROLL_GRADIENT_ID = "visualizer-roll-cylinder";

export const RollGradient = () => (
	<linearGradient id={ROLL_GRADIENT_ID} x1="0%" y1="0%" x2="0%" y2="100%">
		<stop offset="0%" stopColor="#cdd1d6" />
		<stop offset="100%" stopColor="#a3a7ad" />
	</linearGradient>
);
